import React, { useEffect, useState } from 'react';
import {
  getFoundingOfferTimeRemaining,
  getPriceIncreaseTimeRemaining,
  isPriceIncreaseUrgent,
} from '../constants/pricing';

const REMAINING_GETTERS = {
  offer: getFoundingOfferTimeRemaining,
  tier: getPriceIncreaseTimeRemaining,
};

function TimerUnit({ value, label, wide = false }) {
  const display = wide ? String(value) : String(value).padStart(2, '0');
  return (
    <div className="founding-timer-unit">
      <span className="founding-timer-value" aria-hidden="true">
        {display}
      </span>
      <span className="founding-timer-label">{label}</span>
    </div>
  );
}

export default function FoundingCountdownTimer({
  className = '',
  compact = false,
  showSeconds = false,
  target = 'offer',
  urgentThresholdHours = 168,
}) {
  const [parts, setParts] = useState(() => {
    const getRemaining = REMAINING_GETTERS[target] || REMAINING_GETTERS.offer;
    return getRemaining();
  });

  useEffect(() => {
    const getRemaining = REMAINING_GETTERS[target] || REMAINING_GETTERS.offer;
    const tick = () => setParts(getRemaining());
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [target]);

  if (parts.expired) return null;

  const thresholdMs = urgentThresholdHours * 3600000;
  const urgent =
    target === 'tier'
      ? isPriceIncreaseUrgent() || parts.totalMs <= thresholdMs
      : parts.totalMs <= thresholdMs;

  return (
    <div
      className={`founding-timer${compact ? ' is-compact' : ''}${urgent ? ' is-urgent' : ''}${
        target === 'tier' ? ' is-tier' : ''
      }${className ? ` ${className}` : ''}`}
      role="timer"
      aria-live="off"
      aria-label={`${parts.days} days, ${parts.hours} hours, ${parts.minutes} minutes, ${parts.seconds} seconds remaining`}
    >
      <TimerUnit value={parts.days} label="Days" wide />
      <span className="founding-timer-sep" aria-hidden="true">
        :
      </span>
      <TimerUnit value={parts.hours} label="Hours" />
      <span className="founding-timer-sep" aria-hidden="true">
        :
      </span>
      <TimerUnit value={parts.minutes} label="Min" />
      {(!compact || showSeconds) && (
        <>
          <span className="founding-timer-sep" aria-hidden="true">
            :
          </span>
          <TimerUnit value={parts.seconds} label="Sec" />
        </>
      )}
    </div>
  );
}
